#import "./AssetFields.graphql"

mutation ChangeAssetStatus(
  $assetId: ID!
  $status: AssetStatusEnum!
  $location: AssetLocationEnum
  $disposedOn: ISO8601Date
  $disposalMethod: String
) {
  changeAssetStatus(
    input: {
      assetId: $assetId
      status: $status
      location: $location
      disposedOn: $disposedOn
      disposalMethod: $disposalMethod
    }
  ) {
    asset {
      ...AssetFields
    }
  }
}
